import calendarTemplate from './calendarTemplate.html';
import calendarController from './calendar';

export default function ($stateProvider) {
    $stateProvider.state('calendar', {
        parent: 'ng-admin',
        url: '/calendar?:date&:view',
        controller: calendarController,
        template: calendarTemplate
    });
};



// WEBPACK FOOTER //
// ./js/calendar/calendarState.js